// ── Analytics mock data ──────────────────────────────────────────
// Frontend-only mock data for the Analytics page.
// Mirrors design1/src/data/mockData.ts but only includes the
// analytics-related exports (teacher analytics, class trends,
// student trends, topic performance).

export const teachers = [
  { id: 1, name: "Ayşe Yılmaz", subject: "Matematik" },
  { id: 2, name: "Mehmet Demir", subject: "Fizik" },
  { id: 3, name: "Elif Kaya", subject: "Biyoloji" },
  { id: 4, name: "Ahmet Çelik", subject: "Matematik" },
  { id: 5, name: "Fatma Öztürk", subject: "Kimya" },
];

export const teacherAnalytics = [
  {
    teacherId: 1,
    classes: ["8-A"],
    examsGraded: 6,
    avgClassScore: 78.4,
    strongTopics: ["Doğrusal Denklemler", "Cebir"],
    weakTopics: ["Sözel Problemler", "Veri Yorumlama"],
  },
  {
    teacherId: 2,
    classes: ["9-B"],
    examsGraded: 4,
    avgClassScore: 74.1,
    strongTopics: ["Newton Yasaları", "Kinematik"],
    weakTopics: ["Dalga Hareketi", "Termodinamik"],
  },
  {
    teacherId: 3,
    classes: ["7-C"],
    examsGraded: 4,
    avgClassScore: 81.2,
    strongTopics: ["Hücre Yapısı", "Fotosentez"],
    weakTopics: ["Genetik", "Ekoloji"],
  },
  {
    teacherId: 4,
    classes: ["8-B", "9-A"],
    examsGraded: 8,
    avgClassScore: 72.3,
    strongTopics: ["Cebir", "Geometri"],
    weakTopics: ["Sözel Problemler", "Rasyonel Sayılar"],
  },
  {
    teacherId: 5,
    classes: ["10-A"],
    examsGraded: 4,
    avgClassScore: 75.8,
    strongTopics: ["Atom Yapısı", "Kimyasal Bağ"],
    weakTopics: ["Stokiyometri", "Organik Kimya"],
  },
];

// Keys are composite strings of the form "teacherId|classCode"
// difficulty values use the internal keys ('easy'|'medium'|'hard') that
// Analytics.tsx maps to translated labels via t('analytics.difficulty.*').
export const classTrendData: Record<
  string,
  { exam: string; date: string; avg: number; difficulty: "easy" | "medium" | "hard" }[]
> = {
  "1|8-A": [
    { exam: "Quiz #1 — Kümeler", date: "2025-09-20", avg: 68, difficulty: "hard" },
    { exam: "Quiz #2 — Sayı Özellikleri", date: "2025-10-18", avg: 72, difficulty: "medium" },
    { exam: "Dönem Ortası Sınavı", date: "2025-12-05", avg: 71, difficulty: "hard" },
    { exam: "Quiz #3 — Cebir", date: "2026-01-22", avg: 75, difficulty: "medium" },
    { exam: "Ara Sınav — Cebir", date: "2026-02-15", avg: 76, difficulty: "medium" },
    { exam: "Final Matematik Sınavı", date: "2026-03-10", avg: 79, difficulty: "easy" },
  ],
  "4|9-A": [
    { exam: "Quiz #1 — Kümeler", date: "2025-09-22", avg: 70, difficulty: "hard" },
    { exam: "Quiz #2 — Sayı Sistemleri", date: "2025-10-20", avg: 74, difficulty: "medium" },
    { exam: "Dönem Ortası Sınavı", date: "2025-12-08", avg: 73, difficulty: "hard" },
    { exam: "Quiz #3 — Cebir I", date: "2026-01-25", avg: 77, difficulty: "medium" },
    { exam: "Ara Sınav — Cebir", date: "2026-02-18", avg: 78, difficulty: "medium" },
    { exam: "Final Matematik Sınavı", date: "2026-03-12", avg: 81, difficulty: "easy" },
  ],
  "2|9-B": [
    { exam: "Kinematik Sınavı", date: "2025-09-28", avg: 65, difficulty: "hard" },
    { exam: "Kuvvet & Newton Yasaları", date: "2025-11-10", avg: 70, difficulty: "hard" },
    { exam: "Dalga Hareketi Sınavı", date: "2026-01-28", avg: 71, difficulty: "medium" },
    { exam: "Dönemlik Fizik Sınavı", date: "2026-02-20", avg: 82, difficulty: "easy" },
  ],
  "5|10-A": [
    { exam: "Atom Yapısı Quiz", date: "2025-10-05", avg: 74, difficulty: "medium" },
    { exam: "Kimyasal Bağ Sınavı", date: "2025-11-22", avg: 77, difficulty: "medium" },
    { exam: "Stokiyometri Ara Sınav", date: "2026-01-15", avg: 72, difficulty: "hard" },
    { exam: "Kimya Lab Raporu", date: "2026-03-01", avg: 80, difficulty: "easy" },
  ],
  "3|7-C": [
    { exam: "Hücre Quiz", date: "2025-09-15", avg: 78, difficulty: "easy" },
    { exam: "Fotosentez Sınavı", date: "2025-11-01", avg: 82, difficulty: "easy" },
    { exam: "Ekoloji Değerlendirme", date: "2026-01-20", avg: 79, difficulty: "medium" },
    { exam: "Biyoloji Quiz #3", date: "2026-03-05", avg: 84, difficulty: "easy" },
  ],
  "4|8-B": [
    { exam: "Quiz #1 — Kümeler", date: "2025-09-21", avg: 66, difficulty: "hard" },
    { exam: "Quiz #2 — Sayı Özellikleri", date: "2025-10-19", avg: 70, difficulty: "medium" },
    { exam: "Dönem Ortası Sınavı", date: "2025-12-06", avg: 69, difficulty: "hard" },
    { exam: "Quiz #3 — Cebir", date: "2026-01-23", avg: 73, difficulty: "medium" },
    { exam: "Ara Sınav — Cebir", date: "2026-02-16", avg: 74, difficulty: "medium" },
    { exam: "Final Matematik Sınavı", date: "2026-03-11", avg: 77, difficulty: "easy" },
  ],
};

// Keyed by subject name (Turkish).
export const studentTrendData: Record<
  string,
  { studentId: number; name: string; scores: { exam: string; date: string; pct: number }[] }[]
> = {
  Matematik: [
    {
      studentId: 1,
      name: "Ali Yıldız",
      scores: [
        { exam: "Quiz #1 — Kümeler", date: "2025-09-20", pct: 72 },
        { exam: "Quiz #2 — Sayı Özellikleri", date: "2025-10-18", pct: 75 },
        { exam: "Dönem Ortası", date: "2025-12-05", pct: 74 },
        { exam: "Quiz #3 — Cebir", date: "2026-01-22", pct: 80 },
        { exam: "Ara Sınav", date: "2026-02-15", pct: 82 },
        { exam: "Final", date: "2026-03-10", pct: 85 },
      ],
    },
    {
      studentId: 2,
      name: "Zeynep Arslan",
      scores: [
        { exam: "Quiz #1 — Kümeler", date: "2025-09-20", pct: 80 },
        { exam: "Quiz #2 — Sayı Özellikleri", date: "2025-10-18", pct: 84 },
        { exam: "Dönem Ortası", date: "2025-12-05", pct: 87 },
        { exam: "Quiz #3 — Cebir", date: "2026-01-22", pct: 89 },
        { exam: "Ara Sınav", date: "2026-02-15", pct: 91 },
        { exam: "Final", date: "2026-03-10", pct: 93 },
      ],
    },
    {
      studentId: 3,
      name: "Burak Şahin",
      scores: [
        { exam: "Quiz #1 — Kümeler", date: "2025-09-20", pct: 58 },
        { exam: "Quiz #2 — Sayı Özellikleri", date: "2025-10-18", pct: 62 },
        { exam: "Dönem Ortası", date: "2025-12-05", pct: 60 },
        { exam: "Quiz #3 — Cebir", date: "2026-01-22", pct: 65 },
        { exam: "Ara Sınav", date: "2026-02-15", pct: 68 },
        { exam: "Final", date: "2026-03-10", pct: 71 },
      ],
    },
    {
      studentId: 4,
      name: "Selin Doğan",
      scores: [
        { exam: "Quiz #1 — Kümeler", date: "2025-09-20", pct: 82 },
        { exam: "Quiz #2 — Sayı Özellikleri", date: "2025-10-18", pct: 80 },
        { exam: "Dönem Ortası", date: "2025-12-05", pct: 84 },
        { exam: "Quiz #3 — Cebir", date: "2026-01-22", pct: 86 },
        { exam: "Ara Sınav", date: "2026-02-15", pct: 88 },
        { exam: "Final", date: "2026-03-10", pct: 90 },
      ],
    },
    {
      studentId: 5,
      name: "Emre Koç",
      scores: [
        { exam: "Quiz #1 — Kümeler", date: "2025-09-20", pct: 64 },
        { exam: "Quiz #2 — Sayı Özellikleri", date: "2025-10-18", pct: 68 },
        { exam: "Dönem Ortası", date: "2025-12-05", pct: 66 },
        { exam: "Quiz #3 — Cebir", date: "2026-01-22", pct: 70 },
        { exam: "Ara Sınav", date: "2026-02-15", pct: 73 },
        { exam: "Final", date: "2026-03-10", pct: 76 },
      ],
    },
    {
      studentId: 6,
      name: "Defne Aydın",
      scores: [
        { exam: "Quiz #1 — Kümeler", date: "2025-09-20", pct: 88 },
        { exam: "Quiz #2 — Sayı Özellikleri", date: "2025-10-18", pct: 90 },
        { exam: "Dönem Ortası", date: "2025-12-05", pct: 92 },
        { exam: "Quiz #3 — Cebir", date: "2026-01-22", pct: 93 },
        { exam: "Ara Sınav", date: "2026-02-15", pct: 95 },
        { exam: "Final", date: "2026-03-10", pct: 96 },
      ],
    },
    {
      studentId: 7,
      name: "Can Özdemir",
      scores: [
        { exam: "Quiz #1 — Kümeler", date: "2025-09-20", pct: 50 },
        { exam: "Quiz #2 — Sayı Özellikleri", date: "2025-10-18", pct: 52 },
        { exam: "Dönem Ortası", date: "2025-12-05", pct: 48 },
        { exam: "Quiz #3 — Cebir", date: "2026-01-22", pct: 55 },
        { exam: "Ara Sınav", date: "2026-02-15", pct: 59 },
        { exam: "Final", date: "2026-03-10", pct: 62 },
      ],
    },
  ],
  Fizik: [
    {
      studentId: 8,
      name: "Ece Tekin",
      scores: [
        { exam: "Kinematik Sınavı", date: "2025-09-28", pct: 70 },
        { exam: "Kuvvet & Newton", date: "2025-11-10", pct: 74 },
        { exam: "Dalga Hareketi", date: "2026-01-28", pct: 76 },
        { exam: "Dönemlik Fizik", date: "2026-02-20", pct: 82 },
      ],
    },
    {
      studentId: 9,
      name: "Barış Polat",
      scores: [
        { exam: "Kinematik Sınavı", date: "2025-09-28", pct: 62 },
        { exam: "Kuvvet & Newton", date: "2025-11-10", pct: 66 },
        { exam: "Dalga Hareketi", date: "2026-01-28", pct: 68 },
        { exam: "Dönemlik Fizik", date: "2026-02-20", pct: 75 },
      ],
    },
    {
      studentId: 10,
      name: "Deniz Aksoy",
      scores: [
        { exam: "Kinematik Sınavı", date: "2025-09-28", pct: 72 },
        { exam: "Kuvvet & Newton", date: "2025-11-10", pct: 78 },
        { exam: "Dalga Hareketi", date: "2026-01-28", pct: 80 },
        { exam: "Dönemlik Fizik", date: "2026-02-20", pct: 85 },
      ],
    },
  ],
  Kimya: [
    {
      studentId: 11,
      name: "Yusuf Karaca",
      scores: [
        { exam: "Atom Yapısı Quiz", date: "2025-10-05", pct: 76 },
        { exam: "Kimyasal Bağ", date: "2025-11-22", pct: 80 },
        { exam: "Stokiyometri Ara Sınav", date: "2026-01-15", pct: 74 },
        { exam: "Kimya Lab Raporu", date: "2026-03-01", pct: 82 },
      ],
    },
    {
      studentId: 12,
      name: "Irmak Şentürk",
      scores: [
        { exam: "Atom Yapısı Quiz", date: "2025-10-05", pct: 82 },
        { exam: "Kimyasal Bağ", date: "2025-11-22", pct: 85 },
        { exam: "Stokiyometri Ara Sınav", date: "2026-01-15", pct: 78 },
        { exam: "Kimya Lab Raporu", date: "2026-03-01", pct: 88 },
      ],
    },
  ],
  Biyoloji: [
    {
      studentId: 13,
      name: "Kerem Yıldırım",
      scores: [
        { exam: "Hücre Quiz", date: "2025-09-15", pct: 80 },
        { exam: "Fotosentez Sınavı", date: "2025-11-01", pct: 84 },
        { exam: "Ekoloji Değerlendirme", date: "2026-01-20", pct: 78 },
        { exam: "Biyoloji Quiz #3", date: "2026-03-05", pct: 86 },
      ],
    },
    {
      studentId: 14,
      name: "Melis Korkmaz",
      scores: [
        { exam: "Hücre Quiz", date: "2025-09-15", pct: 74 },
        { exam: "Fotosentez Sınavı", date: "2025-11-01", pct: 78 },
        { exam: "Ekoloji Değerlendirme", date: "2026-01-20", pct: 80 },
        { exam: "Biyoloji Quiz #3", date: "2026-03-05", pct: 83 },
      ],
    },
  ],
};

export const studentTopicPerformance: Record<string, Record<number, { topic: string; pct: number }[]>> = {
  Matematik: {
    1: [
      { topic: "Kümeler", pct: 72 },
      { topic: "Sayı Özellikleri", pct: 85 },
      { topic: "Doğrusal Denklemler", pct: 89 },
      { topic: "Sözel Problemler", pct: 60 },
      { topic: "Rasyonel Sayılar", pct: 68 },
      { topic: "Geometri", pct: 82 },
      { topic: "Eşitsizlikler", pct: 87 },
      { topic: "Veri Yorumlama", pct: 75 },
    ],
    2: [
      { topic: "Kümeler", pct: 88 },
      { topic: "Sayı Özellikleri", pct: 90 },
      { topic: "Doğrusal Denklemler", pct: 95 },
      { topic: "Sözel Problemler", pct: 80 },
      { topic: "Rasyonel Sayılar", pct: 87 },
      { topic: "Geometri", pct: 93 },
      { topic: "Eşitsizlikler", pct: 93 },
      { topic: "Veri Yorumlama", pct: 88 },
    ],
    3: [
      { topic: "Kümeler", pct: 55 },
      { topic: "Sayı Özellikleri", pct: 70 },
      { topic: "Doğrusal Denklemler", pct: 78 },
      { topic: "Sözel Problemler", pct: 40 },
      { topic: "Rasyonel Sayılar", pct: 52 },
      { topic: "Geometri", pct: 68 },
      { topic: "Eşitsizlikler", pct: 80 },
      { topic: "Veri Yorumlama", pct: 58 },
    ],
    4: [
      { topic: "Kümeler", pct: 84 },
      { topic: "Sayı Özellikleri", pct: 92 },
      { topic: "Doğrusal Denklemler", pct: 90 },
      { topic: "Sözel Problemler", pct: 70 },
      { topic: "Rasyonel Sayılar", pct: 82 },
      { topic: "Geometri", pct: 86 },
      { topic: "Eşitsizlikler", pct: 95 },
      { topic: "Veri Yorumlama", pct: 85 },
    ],
    5: [
      { topic: "Kümeler", pct: 62 },
      { topic: "Sayı Özellikleri", pct: 78 },
      { topic: "Doğrusal Denklemler", pct: 82 },
      { topic: "Sözel Problemler", pct: 50 },
      { topic: "Rasyonel Sayılar", pct: 60 },
      { topic: "Geometri", pct: 72 },
      { topic: "Eşitsizlikler", pct: 85 },
      { topic: "Veri Yorumlama", pct: 65 },
    ],
    6: [
      { topic: "Kümeler", pct: 92 },
      { topic: "Sayı Özellikleri", pct: 95 },
      { topic: "Doğrusal Denklemler", pct: 98 },
      { topic: "Sözel Problemler", pct: 90 },
      { topic: "Rasyonel Sayılar", pct: 92 },
      { topic: "Geometri", pct: 96 },
      { topic: "Eşitsizlikler", pct: 93 },
      { topic: "Veri Yorumlama", pct: 90 },
    ],
    7: [
      { topic: "Kümeler", pct: 48 },
      { topic: "Sayı Özellikleri", pct: 60 },
      { topic: "Doğrusal Denklemler", pct: 65 },
      { topic: "Sözel Problemler", pct: 30 },
      { topic: "Rasyonel Sayılar", pct: 42 },
      { topic: "Geometri", pct: 58 },
      { topic: "Eşitsizlikler", pct: 72 },
      { topic: "Veri Yorumlama", pct: 52 },
    ],
  },
  Fizik: {
    8: [
      { topic: "Kinematik", pct: 78 },
      { topic: "Newton Yasaları", pct: 82 },
      { topic: "Dalga Hareketi", pct: 70 },
      { topic: "Enerji & İş", pct: 76 },
      { topic: "Termodinamik", pct: 68 },
    ],
    9: [
      { topic: "Kinematik", pct: 65 },
      { topic: "Newton Yasaları", pct: 72 },
      { topic: "Dalga Hareketi", pct: 60 },
      { topic: "Enerji & İş", pct: 68 },
      { topic: "Termodinamik", pct: 55 },
    ],
    10: [
      { topic: "Kinematik", pct: 80 },
      { topic: "Newton Yasaları", pct: 85 },
      { topic: "Dalga Hareketi", pct: 78 },
      { topic: "Enerji & İş", pct: 82 },
      { topic: "Termodinamik", pct: 74 },
    ],
  },
  Kimya: {
    11: [
      { topic: "Atom Yapısı", pct: 76 },
      { topic: "Kimyasal Bağ", pct: 82 },
      { topic: "Stokiyometri", pct: 70 },
      { topic: "Asitler & Bazlar", pct: 74 },
      { topic: "Organik Kimya", pct: 65 },
    ],
    12: [
      { topic: "Atom Yapısı", pct: 84 },
      { topic: "Kimyasal Bağ", pct: 88 },
      { topic: "Stokiyometri", pct: 78 },
      { topic: "Asitler & Bazlar", pct: 82 },
      { topic: "Organik Kimya", pct: 76 },
    ],
  },
  Biyoloji: {
    13: [
      { topic: "Hücre Yapısı", pct: 82 },
      { topic: "Fotosentez", pct: 86 },
      { topic: "Ekoloji", pct: 74 },
      { topic: "Genetik", pct: 70 },
      { topic: "İnsan Vücut Sistemleri", pct: 80 },
    ],
    14: [
      { topic: "Hücre Yapısı", pct: 76 },
      { topic: "Fotosentez", pct: 80 },
      { topic: "Ekoloji", pct: 78 },
      { topic: "Genetik", pct: 72 },
      { topic: "İnsan Vücut Sistemleri", pct: 82 },
    ],
  },
};
